import { translate, translateFormatter } from '@manomano-internal/i18n/esm/placeholders';
export const {
  modalTitle,
  findOutMoreLinkLabel,
  findOutMoreLinkUrl
} = translate({
  "modalTitle": "Unable to add item to cart",
  "findOutMoreLinkLabel": "Find out more",
  "findOutMoreLinkUrl": "https://faq.manomano.com/hc/en-gb/articles/360014190737-Creating-a-ManoManoPro-account"
});
export const modalContent = translateFormatter<{
  platformName: string;
}>("Buying from ManoManoPro UK is no longer allowed because your professional account is associated with ManoManoPro {platformName}.", undefined, undefined, "en");
export const switchToPlatformCTALabel = translateFormatter<{
  platformName: string;
}>("Switch to ManoManoPro {platformName}", undefined, undefined, "en");